import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { memo, useEffect } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';

const refreshState = atom(0);

export function useCountdownRefresh(refresh: boolean) {
  const setRefresh = useSetAtom(refreshState);

  useEffect(() => {
    if (!refresh) return;

    const timer = setInterval(() => {
      setRefresh((pre) => pre + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [refresh, setRefresh]);
}

function CountDown({ time: timeProp }: { time: string | number }) {
  const { t } = useTranslate();

  const lang = useSystemLanguageValue();

  useAtomValue(refreshState);

  const now = Date.now();

  const time = Number(timeProp);

  const seconds = Math.round((now - time) / 1000);

  if (seconds <= 0) {
    return <></>;
  }

  const displaySeconds = seconds % 60;

  const minutes = Math.floor(seconds / 60);

  const secondLabel = t('domain.time.type.second');

  if (!minutes) {
    return <Container>{`${displaySeconds} ${secondLabel}`}</Container>;
  }

  const displayMinutes = minutes % 60;

  const hours = Math.floor(minutes / 60);

  const minuteLabel = lang === 'zh-CN' ? '分' : t('domain.time.type.minute');

  if (!hours) {
    return (
      <Container>{`${displayMinutes} ${minuteLabel} ${displaySeconds} ${secondLabel}`}</Container>
    );
  }

  return (
    <Container>{`${hours} ${
      lang === 'zh-CN' ? '时' : t('domain.time.type.hour')
    } ${displayMinutes} ${minuteLabel} ${displaySeconds} ${secondLabel}`}</Container>
  );
}

const Container = styled.div`
  display: inline-block;
  margin-top: 4px;
  padding: 0 6px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  background: #f56e6e;
  border-radius: 9px;
`;

export default memo(CountDown);
